module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Frick_AG-ff73d5b8d29b772ccd578abfc2e67382.svg";